import React from 'react';
import { Link } from 'react-router-dom';
import imageAvatar from '../assets/image_avatar.png';

interface HeroSectionProps {
  onLoginClick: () => void;
}

const HeroSection: React.FC<HeroSectionProps> = ({ onLoginClick }) => (
  <section className="atlas-top" aria-labelledby="atlas-title">
    <div className="atlas-person">
      <img
        className="atlas-portrait"
        src={imageAvatar}
        width={809}
        height={809}
        alt="Персонаж исторического сайта dmishanin.ru — седовласый мужчина в очках"
      />
      <div className="atlas-intro">
        <span className="eyebrow">ДМИТРИЙ МИШАНИН</span>
        <h1 id="atlas-title">Личная база<br />инженерного опыта<span className="atlas-punctuation">.</span></h1>
        <p>Статьи, инструменты и проекты<br className="atlas-desktop-break" /> из практики разработчика.</p>
        <div className="atlas-hero-actions">
          <Link to="/articles" className="atlas-primary-action">Открыть базу</Link>
          <button type="button" className="atlas-secondary-action" onClick={onLoginClick}>Войти в портал</button>
        </div>
      </div>
    </div>
    <span className="atlas-domain">dmishanin.ru<br />Персональный портал</span>
  </section>
);

export default HeroSection;
